import { connect } from "react-redux";
import React, { Component } from 'react';
import { openStripeBuyProductModal, customerBuyConsumable, confirmConsumablePurchase } from "../../../store/actions/paymentActions";
import { ElementsConsumer } from "@stripe/react-stripe-js";
import STRIPE_LOGO from '../../../assets/svgs/stripe.svg'

class CheckoutForm extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            isProcessing: false,
            isProcessed: false,
            errorMessage: ""
        }
    }

    handleSubmit = async (event) => {
        console.log("PROD AUTH SUBMIT")
        const { stripePaymentIntent } = this.props.payment;
        const { coid, stripeDefaultPmid } = this.props.companyData;

        // Block native form submission.
        event.preventDefault();

        const { stripe, elements } = this.props;

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }

        this.setState({
            isProcessing: true,
            isProcessed: false,
            errorMessage: ""
        }, async () => {
            const { error, paymentIntent } = await stripe.confirmCardPayment(`${stripePaymentIntent.paymentIntentCS}`, {
                payment_method: stripeDefaultPmid,
            });

            if (error) {
                // Display result.error.message in your UI.
                console.log('[error]', error);
                this.setState({
                    isProcessing: true,
                    isProcessed: true,
                    errorMessage: ""
                }, async () => {
                    // update the order on server
                    this.props.confirmConsumablePurchase(stripePaymentIntent.conOrderId);
                })
            } else {
                this.setState({
                    isProcessing: true,
                    isProcessed: true,
                    errorMessage: paymentIntent.status === "succeeded" ? "" : "Authorization has failed. Please try again."
                }, async () => {
                    // update the order on server
                    this.props.confirmConsumablePurchase(stripePaymentIntent.conOrderId);
                })
            }
        });
    };

    render() {
        const { stripe, payment } = this.props;
        const { isBuyProdActing, isBuyProdActed, buyProdActMessage } = payment;
        const { isProcessing, isProcessed } = this.state;
        const relevantComponent = !isProcessed ? !isProcessing ? <button className="btn btn-dark btn-sm" type="submit" disabled={!stripe}>Authorize payment</button> : <button className="btn btn-dark btn-sm" type="button" disabled>
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            &nbsp; Authorizing
        </button> : <React.Fragment />

        const relevantMessage = isBuyProdActed ? <p>{buyProdActMessage}</p> : isBuyProdActing ? <p>Processing...</p> : <p>{buyProdActMessage}</p>

        return (
            <React.Fragment>
                <form onSubmit={this.handleSubmit}>
                    {relevantMessage}
                    {relevantComponent}
                    <p style={{ color: 'red' }}>{this.state.errorMessage}</p>
                </form>
                <img src={STRIPE_LOGO} width="100px" />
            </React.Fragment>
        );
    }
}
class BuyConProductModal extends Component {

    componentDidMount() {
        this.props.openStripeBuyProductModal();
    }

    handleProdBuySubmit = (event) => {
        console.log("PROD BUY SUBMIT")
        event.preventDefault();

        const productId = this.props.priceCard.productId;
        const { coid } = this.props.companyData;
        this.props.customerBuyConsumable(productId)
    }

    // handleProdCancelSubmit = (event) => {
    //     console.log("PROD CANCEL SUBMIT")
    //     event.preventDefault();

    //     const orderId = this.props.productOrder.orderId;
    //     this.props.customerCancelExistingStripeSubsription(orderId)
    // }

    // handleProdUpdateSubmit = (event) => {
    //     console.log("PROD UPDATE SUBMIT")
    //     event.preventDefault();
    // }

    render() {
        const { modalWidth, modalTitleStyle, modalInfoTextStyle, userData, payment, priceCard, productOrder, confirmConsumablePurchase, companyData, commons } = this.props;
        const { isBuyProdActing, isBuyProdActed, buyProdActMessage, stripePaymentIntent } = payment;
        const { itemName, itemDescription, price } = priceCard;

        // check if a product is not a free trial
        const freeTrial = priceCard.tierId === "tier_free";

        const cautionMessage = `This topup will be applied to the active subscription with orderId: ${productOrder.orderId}. `;
        const relevantButton = !isBuyProdActed ? !isBuyProdActing ? <button className="btn btn-dark btn-sm" onClick={this.handleProdBuySubmit} disabled={isBuyProdActing}>Extend your limits <strong>now!</strong></button> : <button className="btn btn-dark btn-sm" type="button" disabled>
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            &nbsp; Topping up your subscription...
        </button> : <React.Fragment />

        let relevantComponentBody = <React.Fragment />;
        if (stripePaymentIntent === "") {
            relevantComponentBody = relevantButton;
        } else if (stripePaymentIntent === "-1") {
            relevantComponentBody = <p>{buyProdActMessage}</p>;
        } else {
            relevantComponentBody = <ElementsConsumer>
                {({ elements, stripe }) => (
                    <CheckoutForm elements={elements} stripe={stripe} userData={userData} companyData={companyData} payment={payment} confirmConsumablePurchase={confirmConsumablePurchase} />
                )}
            </ElementsConsumer>;
        }

        const discountPrice = Number(price).toFixed(0);

        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModalSm">
                    <div className="px-3">
                        <p style={modalTitleStyle}>{itemName}</p>
                        <blockquote className="blockquote">
                            <h3><span>{commons.priceIn}{discountPrice}</span><span style={{ color: "gray" }}> in current subscription</span></h3>
                            <footer className="blockquote-footer">{itemDescription}</footer>
                        </blockquote>
                        <p style={modalInfoTextStyle}>{isBuyProdActed ? '' : cautionMessage}Your card will{freeTrial ? ' not' : ''} be charged at this stage for this product</p>
                        <br />
                    </div>

                    <div className="px-3">
                        {priceCard.stripeProductObject.stripeProductId !== "" ? relevantComponentBody : <p>Product not available yet!</p>}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,

        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,

        userData: state.firebase.profile,
        userId: state.firebase.auth.uid,
        productOrder: state.firestore.data.ProductOrder,
        companyData: state.firestore.data.Company,

        payment: state.payment,
        commons: state.commons,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        openStripeBuyProductModal: () => dispatch(openStripeBuyProductModal()),
        customerBuyConsumable: (productId) => dispatch(customerBuyConsumable(productId)),
        confirmConsumablePurchase: (conOrderId, coid) => dispatch(confirmConsumablePurchase(conOrderId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyConProductModal);